'use client';

import { createContext, ReactNode, useContext } from 'react';
import { IMarketStatsData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketStat';
import useStats from './useStats';
import { IMarketCategoriesData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketCategory';
import { CategoryFilter } from '@/creditflowresearch/ui/components/creditFlow/Stats/config/adapters';

type StatsContextType = ReturnType<typeof useStats>;

export const StatsContext = createContext<StatsContextType>(null);

export const useStatsContext = () => {
  const context = useContext(StatsContext);

  if (!context) {
    throw new Error('useStatsContext must be used within the StatsContext');
  }

  return context;
};

interface IProps {
  categoriesData: IMarketCategoriesData,
  statsData: IMarketStatsData,
  titleWithPrefix: string,
  filterCategory: CategoryFilter,
  children: ReactNode,
}

const StatsContextProvider = ({ children, ...otherProps }: IProps) => (
  <StatsContext.Provider value={ useStats(otherProps) }>
    { children }
  </StatsContext.Provider>
);

export default StatsContextProvider;
